import Vue from "vue";
import Vuex from "vuex";

import "firebase/auth";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {},
  actions: {},
  mutations: {},
  getters: {},
});
